import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, CanActivateChild } from '@angular/router';
import { AuthService } from 'src/backend/services/auth.service';
import { PermissionGuard } from '../user-management/shared/guards/permission.guard';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private authService: AuthService, private router: Router) { }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.isLoggedIn()) {
      if (state.url.indexOf('login') > 0) {
        this.authService.navigateToInitialMenu();
      }
      return true;
    }
    this.authService.redirectionURL = state.url;
    this.router.navigate(['/login']);
    return false;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isLoggedIn()) {
      // skipMenuCheck route data lets sub-pages (e.g. email deep links) bypass the menu check when paired with PermissionGuard.
      if (this.canSkipMenuCheck(route)) {
        this.authService.redirectionURL = state.url;
        return true;
      }
      if (state.url !== '') {
        const hasAccess = this.authService.checkMenuAccess(state.url);
        if (hasAccess) {
          this.authService.redirectionURL = state.url;
          return true;
        }
        else {
          if (state.url !== '/not-found') {
            this.router.navigate(['/not-found']);
          }
          return false;
        }
      }
      return true;
    } else {
      localStorage.setItem('checklistQualityUrl', state.url);
      this.authService.redirectionURL = state.url;
      this.router.navigate(['/login']);
      return false;
    }
  }

  // AuthGuard runs on the parent layout route, so `route` here is that parent. Walk DOWN to the child route
  // that actually carries the skipMenuCheck flag (Angular merges parent data into children, not the other way).
  // Honor the bypass only when that same child also declares PermissionGuard — fail closed otherwise.
  private canSkipMenuCheck(route: ActivatedRouteSnapshot): boolean {
    let cursor: ActivatedRouteSnapshot | null = route;
    while (cursor) {
      if (cursor.data?.['skipMenuCheck']) {
        const guards = cursor.routeConfig?.canActivate ?? [];
        if (guards.includes(PermissionGuard)) return true;
        console.error(
          '[AuthGuard] Route "%s" sets skipMenuCheck without PermissionGuard. Denying access.',
          cursor.routeConfig?.path);
        return false;
      }
      cursor = cursor.firstChild;
    }
    return false;
  }

}
